/**
 * GetCsmsNamesUseCase
 *
 * Fetches the list of available CSMS names for OCPI-to-VPOST connection setup.
 * GET /ocpi-admin/csms/names
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';

export class GetCsmsNamesUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  async execute(): Promise<string[]> {
    return this.repository.getCsmsNames();
  }
}
